import React from 'react';
import { motion } from 'framer-motion';
import { AlertTriangle, Zap, Scale, TrendingDown, Folder } from 'lucide-react';
const costData = [{
  without: 'Armar el CV sin sistema',
  cost: 'Horas perdidas en un documento que igual no pasa el filtro ATS'
}, {
  without: 'Sin palabras clave correctas',
  cost: 'El 75% de tus postulaciones son descartadas automáticamente'
}, {
  without: 'Sin script de negociación',
  cost: 'Aceptás el primer número que te ofrecen y dejás miles de pesos sobre la mesa'
}, {
  without: 'Sin método de seguimiento',
  cost: 'Los procesos se enfrían y nunca sabés si escribir o esperar'
}, {
  without: 'Sin preparación para entrevistas',
  cost: 'La ansiedad te juega en contra justo cuando más importa'
}, {
  without: 'Sin sistema de postulación',
  cost: 'Cada semana empezás de cero sin tracción acumulada'
}];
export function CostTable() {
  return <section className="py-16 bg-graphite relative overflow-hidden" data-id="element-144">
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[700px] h-[700px] bg-red-500/5 blur-[120px] rounded-full pointer-events-none" data-id="element-145"></div>

      <div className="container mx-auto px-4 relative z-10" data-id="element-146">
        {/* Framed Header */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="relative max-w-3xl mx-auto mb-12" data-id="element-147">
          {/* Section Folder Tab */}
          <div className="absolute -top-6 left-6 md:left-10 z-20" data-id="element-148">
            <div className="bg-petroleum border-2 border-b-0 border-red-500/40 rounded-t-lg px-4 py-1.5 flex items-center gap-2 transform -rotate-2" data-id="element-149">
              <Folder className="w-3.5 h-3.5 text-red-400" data-id="element-150" />
              <span className="text-[11px] font-mono font-bold uppercase tracking-widest text-red-400" data-id="element-151">
                Presupuesto.xlsx
              </span>
            </div>
          </div>

          <div className="absolute -inset-1 bg-gradient-to-r from-red-500 via-red-400 to-red-500 rounded-3xl blur-xl opacity-25 animate-pulse" data-id="element-152"></div>
          <div className="relative bg-gradient-to-br from-graphite via-petroleum to-graphite border-2 border-red-500 rounded-3xl p-8 md:p-10 text-center overflow-hidden shadow-2xl shadow-red-500/20" data-id="element-153">
            <div className="absolute inset-0 opacity-[0.08] pointer-events-none" style={{
            backgroundImage: 'linear-gradient(rgba(239,68,68,0.6) 1px, transparent 1px), linear-gradient(90deg, rgba(239,68,68,0.6) 1px, transparent 1px)',
            backgroundSize: '24px 24px'
          }} data-id="element-154"></div>
            <div className="absolute top-0 left-0 w-14 h-14 border-t-4 border-l-4 border-red-500 rounded-tl-3xl pointer-events-none" data-id="element-155"></div>
            <div className="absolute top-0 right-0 w-14 h-14 border-t-4 border-r-4 border-red-500 rounded-tr-3xl pointer-events-none" data-id="element-156"></div>
            <div className="absolute bottom-0 left-0 w-14 h-14 border-b-4 border-l-4 border-red-500 rounded-bl-3xl pointer-events-none" data-id="element-157"></div>
            <div className="absolute bottom-0 right-0 w-14 h-14 border-b-4 border-r-4 border-red-500 rounded-br-3xl pointer-events-none" data-id="element-158"></div>

            <div className="relative z-10" data-id="element-159">
              {/* Metadata header strip */}
              <div className="border-b border-dashed border-white/10 pb-2 mb-4 text-[10px] font-mono uppercase tracking-widest text-textsecondary flex justify-center gap-4" data-id="element-160">
                <span data-id="element-161">Reporte de Gastos N° 001</span>
                <span data-id="element-162">•</span>
                <span data-id="element-163">Fecha: Actual</span>
              </div>

              <div className="inline-flex items-center gap-2 bg-red-500 text-white px-4 py-1.5 rounded-full text-xs font-extrabold uppercase tracking-wider mb-5 shadow-lg shadow-red-500/40" data-id="element-164">
                <Scale className="w-3.5 h-3.5" strokeWidth={2.5} data-id="element-165" />
                El costo real
              </div>
              <h2 className="text-2xl md:text-4xl font-extrabold leading-tight" data-id="element-166">
                <span className="text-white" data-id="element-167">¿Cuánto cuesta </span>
                <span className="text-transparent bg-clip-text bg-gradient-to-r from-red-400 via-red-300 to-red-400 drop-shadow-[0_0_12px_rgba(239,68,68,0.4)]" data-id="element-168">
                  no tenerlo?
                </span>
              </h2>
              <div className="mt-4 mx-auto h-px w-32 bg-gradient-to-r from-transparent via-red-500 to-transparent opacity-70" data-id="element-169"></div>
            </div>
          </div>
        </motion.div>

        {/* Desktop table */}
        <div className="max-w-3xl mx-auto mb-10 hidden md:block" data-id="element-170">
          <div className="bg-gradient-to-br from-petroleum to-graphite border border-red-500/25 rounded-2xl overflow-hidden shadow-xl shadow-red-500/5 relative" data-id="element-171">
            {/* Ruled-paper lines */}
            <div className="absolute inset-0 opacity-[0.03] pointer-events-none z-0" style={{
            backgroundImage: 'repeating-linear-gradient(0deg, #ffffff 0px, #ffffff 1px, transparent 1px, transparent 32px)'
          }} data-id="element-172"></div>

            <table className="w-full text-left border-collapse relative z-10" data-id="element-173">
              <thead data-id="element-174">
                <tr className="bg-graphite/70" data-id="element-175">
                  <th className="p-5 border-b border-white/10 text-textsecondary font-semibold text-xs uppercase tracking-widest" data-id="element-176">
                    <span className="inline-flex items-center gap-2" data-id="element-177">
                      <span className="w-6 h-6 rounded-md bg-white/5 flex items-center justify-center" data-id="element-178">
                        <TrendingDown className="w-3.5 h-3.5" data-id="element-179" />
                      </span>
                      Sin el SuperPack
                    </span>
                  </th>
                  <th className="p-5 border-b-2 border-red-500/40 text-red-400 font-extrabold text-xs uppercase tracking-widest bg-red-500/5" data-id="element-180">
                    <span className="inline-flex items-center gap-2" data-id="element-181">
                      <span className="w-6 h-6 rounded-md bg-red-500/20 flex items-center justify-center" data-id="element-182">
                        <AlertTriangle className="w-3.5 h-3.5" data-id="element-183" />
                      </span>
                      Costo real
                    </span>
                  </th>
                </tr>
              </thead>
              <tbody data-id="element-184">
                {costData.map((row, i) => <tr key={i} className="border-b border-dashed border-white/10 last:border-0 hover:bg-white/[0.02] transition-colors group" data-id="element-185">
                    <td className="p-5 text-white font-medium align-top" data-id="element-186">
                      <span className="inline-flex items-start gap-3" data-id="element-187">
                        <span className="font-mono text-textsecondary/50 text-xs mt-1" data-id="element-188">
                          {String(i + 1).padStart(2, '0')}
                        </span>
                        {row.without}
                      </span>
                    </td>
                    <td className="p-5 text-red-300 font-semibold align-top bg-red-500/[0.04] group-hover:bg-red-500/[0.08] transition-colors border-l border-dashed border-red-500/20" data-id="element-189">
                      <span className="inline-flex items-start gap-2" data-id="element-190">
                        <AlertTriangle className="w-4 h-4 text-red-400 shrink-0 mt-0.5" data-id="element-191" />
                        {row.cost}
                      </span>
                    </td>
                  </tr>)}
              </tbody>
            </table>
          </div>
        </div>

        {/* Mobile cards */}
        <div className="max-w-2xl mx-auto mb-10 md:hidden space-y-3" data-id="element-192">
          {costData.map((row, i) => <motion.div key={i} initial={{
          opacity: 0,
          y: 15
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: i * 0.04
        }} className="bg-gradient-to-br from-petroleum to-graphite border border-red-500/20 rounded-2xl overflow-hidden shadow-lg relative" data-id="element-193">
              {/* Ruled-paper lines */}
              <div className="absolute inset-0 opacity-[0.03] pointer-events-none z-0" style={{
            backgroundImage: 'repeating-linear-gradient(0deg, #ffffff 0px, #ffffff 1px, transparent 1px, transparent 32px)'
          }} data-id="element-194"></div>

              <div className="px-5 py-3 bg-graphite/60 border-b border-dashed border-white/10 flex items-center gap-2.5 relative z-10" data-id="element-195">
                <span className="font-mono text-textsecondary/50 text-xs" data-id="element-196">
                  {String(i + 1).padStart(2, '0')}
                </span>
                <p className="text-white font-semibold text-sm" data-id="element-197">
                  {row.without}
                </p>
              </div>
              <div className="px-5 py-4 bg-red-500/[0.06] relative z-10" data-id="element-198">
                <div className="inline-flex items-center gap-1.5 text-red-400 text-[10px] font-bold uppercase tracking-wider mb-1.5" data-id="element-199">
                  <AlertTriangle className="w-3 h-3" data-id="element-200" /> Costo real
                </div>
                <p className="text-red-300 text-sm font-semibold" data-id="element-201">{row.cost}</p>
              </div>
            </motion.div>)}
        </div>

        {/* Closing quote card */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="relative max-w-3xl mx-auto" data-id="element-202">
          <div className="absolute -inset-0.5 bg-gradient-to-r from-gold/40 via-yellow-300/30 to-gold/40 rounded-2xl blur-lg opacity-40" data-id="element-203"></div>
          <div className="relative bg-gradient-to-br from-petroleum to-graphite border border-gold/40 rounded-2xl p-8 text-center shadow-[0_0_30px_rgba(212,166,42,0.12)]" data-id="element-204">
            <p className="text-base md:text-lg text-textsecondary mb-3" data-id="element-205">
              El próximo proceso puede ser diferente.
            </p>
            <h3 className="text-xl md:text-3xl font-extrabold text-transparent bg-clip-text bg-gradient-to-r from-yellow-300 via-gold to-yellow-400 leading-snug flex items-center justify-center gap-3 flex-wrap" data-id="element-206">
              <Zap className="w-6 h-6 md:w-7 md:h-7 text-gold fill-gold drop-shadow-[0_0_8px_rgba(212,166,42,0.6)]" data-id="element-207" />
              <span data-id="element-208">
                "La próxima entrevista que consigas puede ser la que cambie
                todo. Solo necesitás el sistema correcto para llegar hasta ahí."
              </span>
            </h3>
            <div className="mt-5 mx-auto h-px w-32 bg-gradient-to-r from-transparent via-gold to-transparent opacity-60" data-id="element-209"></div>
          </div>
        </motion.div>
      </div>
    </section>;
}